import axios from "./productInstance";
import { CreateBundleItem } from "@/types/product";

const assignBundleItems = async (
    bundle: CreateBundleItem[],
    productId: string,
    bundleId?: string | null
): Promise<{
    id?: string | null,
    message?: string | null,
    type: "UPDATE" | "CREATE"
}> => {
    try {
        const bundleUrl = bundleId ? `/bundles/${bundleId}/products` : "/bundles/";

        const payload = !bundleId
            ? {
                bundle_product_ids: bundle,
                product_id: productId,
            }
            : bundle[0];

        console.log("payload", bundleId, payload, bundle);
        const response = await axios.post(bundleUrl, payload);

        if (bundleId) {
            return {
                id: bundleId,
                message: response.data?.message || null,
                type: "UPDATE"
            };
        } else {
            return {
                id: response.data?.id || null,
                message: response.data?.message || null,
                type: "CREATE"
            };
        }


    } catch (error: any) {
        console.error("Error creating bundle product:", error?.response?.data || error.message);

        const errorMessage =
            error?.response?.data?.error.replace(/_/g, " ") || "Unknown error occurred while creating bundle product";

        throw new Error(errorMessage);
    }
};

export default assignBundleItems;
